<div class="layout">
  <mat-sidenav-container autosize class="sidenav-container w-100-percent">
    <mat-sidenav #sidenav class="sidenav" mode="side" opened="true" (mouseenter)="mouseEnter()" (mouseleave)="mouseLeave()"
      [ngClass]="{'disable-scroll': sidenavService.rightExpanded, 'collapsed': !sidenavService.isShowing && !sidenavService.isExpanded}">
      <app-side-navigation [disableSideNav]="sidenavService.rightExpanded"></app-side-navigation>
    </mat-sidenav>
    <mat-sidenav-content class="flex justify-center items-center sidenav-content">
      <mat-sidenav-container class="flex-auto right-container" (backdropClick)="sidenavService.backdropClicked()">
        <mat-sidenav #rightSidenav (closed)="sidenavService.resetAfterClosed()"
                     [(opened)]="sidenavService.rightExpanded"
                     [autoFocus]="false"
                     class="right-sidenav" position="end">
          <ng-container #container></ng-container>
        </mat-sidenav>
        <mat-sidenav-content #scrollableContainer (scroll)="scroll($event)" class="flex-col items-center layout-background content-wrapper">
          <div *ngIf="!closed" class="switch-view flex flex-row w-100-percent">
            <div class="flex flex-row w-100-percent justify-center pt-16 pb-16">
              <mat-icon svgIcon="campaign" class="w-32 h-32 mr-8"></mat-icon>
              <span class="pt-4 fw-600 fs-18">{{ 'TOOLBAR.SWITCH_TENANT_DESCRIPTION' | transloco }}</span>
              <a href="javascript:void(0);" (click)="onSwitchClick()" class="pt-4 fw-500 fs-16 ml-32">{{ 'TOOLBAR.SWITCH' | transloco }}</a>
            </div>
            <div class="flex justify-end pt-16 mr-16">
              <mat-icon svgIcon="close" class="cursor-pointer" (click)="closeMenu($event)"></mat-icon>
            </div>
          </div>
          <div class="content">
            <div class="pb-20">
              <router-outlet></router-outlet>
            </div>
            <!-- <app-footer class="footer"></app-footer> -->
          </div>
        </mat-sidenav-content>
      </mat-sidenav-container>
    </mat-sidenav-content>
  </mat-sidenav-container>
</div>
